export class ArithmeticModel {
  constructor(
    public target = '',
    public manipulation: { formula: string; quillObject: null | unknown } = { formula: '', quillObject: null }, // TODO: unknown?
    public manipulationType = 'Arithmetic',
  ) {}
}
